import { z } from 'zod'

export const maintenanceSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  description: z.string().optional(),
  category: z.string().optional(),
  priority: z.enum(['low', 'normal', 'urgent']),
  customer_id: z.string().optional(),
  status: z.enum(['open', 'in_progress', 'completed']),
})

export type MaintenanceFormData = z.infer<typeof maintenanceSchema>
